import React from "react";

interface BotSvgProps {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const BotSvg: React.FC<BotSvgProps> = ({ width = 32, height = 32, style }) => (
  <svg width={width} height={height} style={style} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.3333 1.33398L23.6533 5.00065L19.9999 6.66732L23.6533 8.34732L25.3333 12.0007L26.9999 8.34732L30.6666 6.66732L26.9999 5.00065M11.9999 5.33398L8.66659 12.6673L1.33325 16.0007L8.66659 19.334L11.9999 26.6673L15.3333 19.334L22.6666 16.0007L15.3333 12.6673M25.3333 20.0007L23.6533 23.654L19.9999 25.334L23.6533 27.0007L25.3333 30.6673L26.9999 27.0007L30.6666 25.334L26.9999 23.654" fill="white"/>
  </svg>
);

export default BotSvg;
